import React, { useState } from 'react';
import {
  Check,
  Star,
  X,
  User,
  Mail,
  Phone,
  MessageCircle,
  CheckCircle,
  Search,
  CreditCard,
  Calendar,
  Lock,
} from 'lucide-react';

const Packages = () => {
  // حالة لإظهار/إخفاء نافذة طلب الباقة المخصصة
  const [isCustomRequestModalOpen, setIsCustomRequestModalOpen] = useState(false);
  // حالة لإظهار/إخفاء نافذة حجز الباقة
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  // حالة للتحكم في رسالة النجاح بعد إرسال نموذج الباقة المخصصة
  const [isCustomRequestSubmitted, setIsCustomRequestSubmitted] = useState(false);
  // حالة للتحكم في رسالة النجاح بعد إرسال نموذج الحجز
  const [isBookingSubmitted, setIsBookingSubmitted] = useState(false);
  // حالة لبيانات نموذج الطلب المخصص
  const [customRequestData, setCustomRequestData] = useState({
    name: '',
    email: '',
    phone: '',
    notes: ''
  });
  // حالة لبيانات نموذج الحجز
  const [bookingData, setBookingData] = useState({
    name: '',
    email: '',
    phone: '',
    notes: ''
  });
  // حالة للبحث عن التحاليل
  const [searchQuery, setSearchQuery] = useState('');
  // حالة للتحاليل التي تم اختيارها من قبل المستخدم
  const [selectedServices, setSelectedServices] = useState([]);
  // حالة لتخزين تفاصيل الباقة التي يتم حجزها
  const [selectedPackage, setSelectedPackage] = useState(null);

  // ********* حالة ونموذج الدفع *********
  const [paymentData, setPaymentData] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: ''
  });
  const [formType, setFormType] = useState('booking'); // 'booking' or 'payment'

  // قائمة الباقات المتوفرة
  const packages = [
    {
      name: "باقة الفحص الشامل",
      price: "299",
      originalPrice: "450",
      description: "فحص شامل للجسم يشمل أهم التحاليل الأساسية",
      features: [
        "تحليل صورة دم كاملة",
        "تحليل وظائف الكلى",
        "تحليل وظائف الكبد",
        "تحليل السكر",
        "تحليل الكوليسترول",
        "تحليل البول الكامل",
        "استشارة طبية مجانية"
      ],
      popular: false,
      color: "border-blue-200"
    },
    {
      name: "باقة فحص الحمل",
      price: "349",
      originalPrice: "500",
      description: "باقة متكاملة لمتابعة صحة الأم والجنين خلال فترة الحمل",
      features: [
        "تحليل صورة دم كاملة",
        "تحليل فصيلة الدم وعامل Rh",
        "تحليل سكر الدم",
        "تحليل وظائف الكلى والكبد",
        "تحليل الحديد والفيريتين",
        "تحليل الهرمونات الأساسية",
        "تحليل شامل للبول",
        "استشارة طبيبة نساء وتوليد"
      ],
      popular: false,
      color: "border-pink-200"
    },
    {
      name: "باقة الصحة المتقدمة",
      price: "499",
      originalPrice: "750",
      description: "فحص متقدم يشمل تحاليل متخصصة للوقاية المبكرة",
      features: [
        "جميع تحاليل الباقة الأساسية",
        "تحليل الهرمونات",
        "تحليل الفيتامينات",
        "تحليل دلالات الأورام",
        "تحليل Inbody",
        "تخطيط القلب",
        "استشارة طبية متخصصة",
        "متابعة لمدة 3 أشهر"
      ],
      popular: true,
      color: "border-teal-300"
    },
    {
      name: "باقة كبار السن",
      price: "399",
      originalPrice: "600",
      description: "باقة مصممة خصيصاً لاحتياجات كبار السن",
      features: [
        "تحليل صورة دم كاملة",
        "تحليل وظائف القلب",
        "تحليل هشاشة العظام",
        "تحليل السكر التراكمي",
        "تحليل وظائف الغدة الدرقية",
        "قياس الضغط والنبض",
        "استشارة طبية متخصصة"
      ],
      popular: false,
      color: "border-purple-200"
    }
  ];

  // قائمة التحاليل الكاملة التي قدمتها
  const allServices = [
    "تحليل صورة الدم الكاملة (CBC)",
    "تحليل وظائف الكبد (LFTs)",
    "تحليل وظائف الكلى (KFTs)",
    "تحليل السكر التراكمي (HbA1c)",
    "تحليل الغدة الدرقية (TSH, T3, T4)",
    "تحليل الفيتامينات والمعادن",
    "تحليل الدهون الكاملة (Lipid Panel)",
    "تحليل البول الكامل (Urine Analysis)",
    "تحليل الحمل (Pregnancy Test)",
    "تحليل الأنسولين (Insulin Test)",
    "تحليل الكوليسترول (LDL, HDL)",
    "تحليل المخدرات (Drug Screening)",
    "تحليل الهرمونات",
    "تحليل الفيروسات",
    "تحليل السائل المنوي",
    "تحليل الدم الخفي في البراز",
    "تحليل PSA للبروستاتا",
    "تحليل دلالات الأورام",
    "تحليل فيتامين د",
    "تحليل نسبة الحديد والفيريتين",
    "تحليل وظائف القلب (Troponin)",
    "تحليل PCR للفيروسات",
    "تحليل الحساسية"
  ];

  // دالة لفتح نافذة طلب الباقة المخصصة
  const openCustomRequestModal = () => {
    setIsCustomRequestModalOpen(true);
    setIsCustomRequestSubmitted(false);
  };

  // دالة لإغلاق نافذة طلب الباقة المخصصة
  const closeCustomRequestModal = () => {
    setIsCustomRequestModalOpen(false);
    setSearchQuery('');
    setSelectedServices([]);
    setCustomRequestData({
      name: '',
      email: '',
      phone: '',
      notes: ''
    });
  };

  // دالة لفتح نافذة حجز باقة محددة
  const openBookingModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsBookingModalOpen(true);
    setIsBookingSubmitted(false);
    setFormType('booking');
    // إعادة ضبط بيانات النموذج
    setBookingData({
      name: '',
      email: '',
      phone: '',
      notes: ''
    });
    setPaymentData({
      cardNumber: '',
      expiryDate: '',
      cvv: ''
    });
  };

  // دالة لإغلاق نافذة حجز الباقة
  const closeBookingModal = () => {
    setIsBookingModalOpen(false);
    setSelectedPackage(null);
  };

  // دالة للتعامل مع تغييرات نموذج الطلب المخصص
  const handleCustomRequestChange = (e) => {
    setCustomRequestData({ ...customRequestData, [e.target.name]: e.target.value });
  };

  // دالة للتعامل مع تغييرات نموذج الحجز
  const handleBookingChange = (e) => {
    setBookingData({ ...bookingData, [e.target.name]: e.target.value });
  };

  // دالة للتعامل مع تغييرات نموذج الدفع
  const handlePaymentChange = (e) => {
    setPaymentData({ ...paymentData, [e.target.name]: e.target.value });
  };

  // دالة للتعامل مع إرسال نموذج الطلب المخصص
  const handleCustomRequestSubmit = (e) => {
    e.preventDefault();
    const finalRequestData = {
      ...customRequestData,
      selectedServices: selectedServices.join(', ')
    };
    console.log("Custom package request submitted:", finalRequestData);
    setIsCustomRequestSubmitted(true);
  };

  // دالة للتعامل مع إرسال نموذج الحجز
  const handleBookingSubmit = (e) => {
    e.preventDefault();
    setFormType('payment'); // تغيير نوع النموذج إلى الدفع بعد إرسال بيانات الحجز
  };

  // دالة للتعامل مع إرسال نموذج الدفع
  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    const finalPaymentData = {
      ...paymentData,
      packageName: selectedPackage.name,
      ...bookingData
    };
    console.log("Payment submitted:", finalPaymentData);
    setIsBookingSubmitted(true);
  };

  // دالة للتعامل مع تغيير حقل البحث
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // دالة للتعامل مع تغييرات التحاليل المختارة
  const handleServiceChange = (e) => {
    const serviceName = e.target.value;
    if (e.target.checked) {
      setSelectedServices([...selectedServices, serviceName]);
    } else {
      setSelectedServices(selectedServices.filter(service => service !== serviceName));
    }
  };

  // دالة لإزالة تحليل مختار
  const handleRemoveService = (serviceToRemove) => {
    setSelectedServices(selectedServices.filter(service => service !== serviceToRemove));
  };

  // تصفية قائمة التحاليل بناءً على البحث
  const filteredServices = allServices.filter(service =>
    service.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <section id="packages" className="py-24 bg-slate-50 font-sans text-right">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 rounded-full bg-teal-50 text-teal-700 text-sm font-semibold px-4 py-1.5 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-teal-500"></span>
            عروض متكاملة
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-blue-900 mb-5 tracking-tight">
            الباقات المتخصصة
          </h2>
          <div className="w-16 h-1 rounded-full bg-gradient-to-r from-blue-600 to-teal-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            اختر الباقة المناسبة لك من مجموعة متنوعة من الفحوصات الشاملة بأسعار مميزة
          </p>
        </div>

        {/* Packages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-3xl p-8 border-t-8 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 ${pkg.popular ? 'ring-2 ring-teal-400 scale-105 border-teal-400' : pkg.color}`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="bg-gradient-to-l from-blue-700 to-teal-600 text-white rounded-full px-4 py-1 flex items-center gap-1 shadow-lg">
                    <Star className="w-4 h-4" />
                    <span>الأكثر طلباً</span>
                  </div>
                </div>
              )}

              <div className="text-center pb-4 border-b border-gray-200 mb-6">
                <h3 className="text-2xl text-gray-800 font-bold mb-2">{pkg.name}</h3>
                <div className="space-y-2">
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-4xl font-extrabold text-blue-900">{pkg.price}</span>
                    <span className="text-xl text-gray-600">جنية</span>
                  </div>
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-sm text-gray-500 line-through">بدلاً من {pkg.originalPrice} جنية</span>
                  </div>
                </div>
                <p className="text-gray-600 mt-4">
                  {pkg.description}
                </p>
              </div>

              <div className="space-y-4">
                <ul className="space-y-3">
                  {pkg.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start gap-3 text-right">
                      <Check className="w-5 h-5 text-teal-600 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => openBookingModal(pkg)}
                  className={`w-full mt-6 py-3 px-8 rounded-full font-semibold text-lg shadow-md hover:shadow-lg transition-all duration-300 text-white ${pkg.popular ? 'bg-gradient-to-l from-blue-700 to-teal-600' : 'bg-blue-800 hover:bg-blue-900'}`}
                >
                  احجز الآن
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-br from-blue-900 to-teal-800 rounded-3xl p-10 max-w-4xl mx-auto shadow-lg">
            <h3 className="text-2xl font-bold text-white mb-4">
              لديك احتياجات خاصة؟
            </h3>
            <p className="text-blue-100/80 mb-6">
              يمكننا تصميم باقة مخصصة تناسب احتياجاتك الطبية الخاصة
            </p>
            <button
              onClick={openCustomRequestModal}
              className="bg-white text-blue-900 hover:bg-teal-50 font-semibold py-3 px-8 rounded-full shadow-lg transition-colors duration-300 text-lg"
            >
              طلب باقة مخصصة
            </button>
          </div>
        </div>
      </div>

      {/* نافذة طلب الباقة المخصصة (Modal) */}
      {isCustomRequestModalOpen && (
        <div className="fixed inset-0 bg-blue-950/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md mx-auto relative transform transition-all duration-300 scale-100 text-right">
            <button
              onClick={closeCustomRequestModal}
              className="absolute top-4 left-4 text-gray-400 hover:text-gray-600"
              aria-label="إغلاق"
            >
              <X className="w-6 h-6" />
            </button>

            {!isCustomRequestSubmitted ? (
              <>
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-blue-900">
                    طلب باقة مخصصة
                  </h3>
                  <p className="text-gray-600 mt-2">
                    املأ النموذج وسنتواصل معك قريباً لتصميم باقتك.
                  </p>
                </div>
                <form
                  onSubmit={handleCustomRequestSubmit}
                  className="space-y-4 max-h-[60vh] overflow-y-auto"
                >
                  <div>
                    <label htmlFor="custom-name" className="block text-sm font-medium text-gray-700">
                      الاسم الكامل
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <input
                        type="text"
                        id="custom-name"
                        name="name"
                        value={customRequestData.name}
                        onChange={handleCustomRequestChange}
                        required
                        className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                      />
                      <div className="absolute inset-y-0 right-0 pl-3 flex items-center pointer-events-none">
                        <User className="h-5 w-5 text-gray-400" />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="custom-email" className="block text-sm font-medium text-gray-700">
                      البريد الإلكتروني
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <input
                        type="email"
                        id="custom-email"
                        name="email"
                        value={customRequestData.email}
                        onChange={handleCustomRequestChange}
                        required
                        className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                      />
                      <div className="absolute inset-y-0 right-0 pl-3 flex items-center pointer-events-none">
                        <Mail className="h-5 w-5 text-gray-400" />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="custom-phone" className="block text-sm font-medium text-gray-700">
                      رقم الهاتف
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <input
                        type="tel"
                        id="custom-phone"
                        name="phone"
                        value={customRequestData.phone}
                        onChange={handleCustomRequestChange}
                        required
                        className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                      />
                      <div className="absolute inset-y-0 right-0 pl-3 flex items-center pointer-events-none">
                        <Phone className="h-5 w-5 text-gray-400" />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="serviceType" className="block text-sm font-medium text-gray-700 mb-2">
                      التحاليل المطلوبة (يمكنك اختيار أكثر من تحليل)
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm mb-4">
                      <input
                        type="text"
                        placeholder="ابحث عن تحليل..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                      />
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <Search className="h-5 w-5 text-gray-400" />
                      </div>
                    </div>
                    <div className="p-4 bg-gray-50 rounded-lg border border-gray-200 max-h-40 overflow-y-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-right">
                      {filteredServices.length > 0 ? (
                        filteredServices.map((service, index) => (
                          <div key={index} className="flex items-center space-x-2 rtl:space-x-reverse cursor-pointer">
                            <input
                              type="checkbox"
                              id={`service-${index}`}
                              name="serviceType"
                              value={service}
                              checked={selectedServices.includes(service)}
                              onChange={handleServiceChange}
                              className="h-4 w-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500 cursor-pointer"
                            />
                            <label htmlFor={`service-${index}`} className="text-sm text-gray-700 cursor-pointer">
                              {service}
                            </label>
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-500 text-sm text-center col-span-full">لا توجد نتائج مطابقة.</p>
                      )}
                    </div>
                  </div>
                  {selectedServices.length > 0 && (
                    <div className="mt-4 p-4 bg-teal-50 rounded-lg border border-teal-200">
                      <h4 className="text-lg font-bold text-teal-800 mb-2">التحاليل المحددة:</h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-right">
                        {selectedServices.map((service, index) => (
                          <div
                            key={index}
                            className="bg-teal-100 text-teal-900 text-sm font-medium px-3 py-1 rounded-full border border-teal-300 flex items-center gap-1 rtl:flex-row-reverse justify-between"
                          >
                            <span>{service}</span>
                            <button
                              type="button"
                              onClick={() => handleRemoveService(service)}
                              className="text-teal-500 hover:text-teal-700 p-1 rounded-full hover:bg-teal-200 transition-colors cursor-pointer"
                              aria-label={`إزالة ${service}`}
                            >
                              <X className="w-4 h-4" />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div>
                    <label htmlFor="custom-notes" className="block text-sm font-medium text-gray-700">
                      إضافات أو ملاحظات أخرى
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <textarea
                        id="custom-notes"
                        name="notes"
                        rows="3"
                        placeholder="أذكر أي تفاصيل إضافية أو ملاحظات هامة (اختياري)"
                        value={customRequestData.notes}
                        onChange={handleCustomRequestChange}
                        className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                      ></textarea>
                      <div className="absolute top-3 right-0 pl-3 flex items-start pointer-events-none">
                        <MessageCircle className="h-5 w-5 text-gray-400" />
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-6">
                    <button
                      type="submit"
                      className="w-full bg-gradient-to-l from-blue-700 to-teal-600 text-white font-bold py-3 px-8 rounded-full hover:shadow-lg transition duration-300 shadow-md"
                    >
                      إرسال الطلب
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <div className="text-center p-8">
                <CheckCircle className="w-16 h-16 mx-auto text-teal-500 mb-4" />
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  تم إرسال طلبك بنجاح!
                </h3>
                <p className="text-gray-600">
                  سنتواصل معك في أقرب وقت لتصميم باقتك.
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* نافذة حجز باقة محددة (Modal) */}
      {isBookingModalOpen && selectedPackage && (
        <div className="fixed inset-0 bg-blue-950/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md mx-auto relative transform transition-all duration-300 scale-100 text-right">
            <button
              onClick={closeBookingModal}
              className="absolute top-4 left-4 text-gray-400 hover:text-gray-600"
              aria-label="إغلاق"
            >
              <X className="w-6 h-6" />
            </button>

            {!isBookingSubmitted ? (
              <>
                {formType === 'booking' && (
                  <>
                    <div className="text-center mb-6">
                      <h3 className="text-2xl font-bold text-blue-900">
                        حجز باقة: {selectedPackage.name}
                      </h3>
                      <p className="text-gray-600 mt-2">
                        يرجى ملء البيانات التالية لإتمام الحجز.
                      </p>
                    </div>
                    <form
                      onSubmit={handleBookingSubmit}
                      className="space-y-4 max-h-[60vh] overflow-y-auto"
                    >
                      <div>
                        <label htmlFor="booking-name" className="block text-sm font-medium text-gray-700">
                          الاسم الكامل
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="text"
                            id="booking-name"
                            name="name"
                            value={bookingData.name}
                            onChange={handleBookingChange}
                            required
                            className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                          />
                          <div className="absolute inset-y-0 right-0 pl-3 flex items-center pointer-events-none">
                            <User className="h-5 w-5 text-gray-400" />
                          </div>
                        </div>
                      </div>
                      <div>
                        <label htmlFor="booking-email" className="block text-sm font-medium text-gray-700">
                          البريد الإلكتروني
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="email"
                            id="booking-email"
                            name="email"
                            value={bookingData.email}
                            onChange={handleBookingChange}
                            required
                            className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                          />
                          <div className="absolute inset-y-0 right-0 pl-3 flex items-center pointer-events-none">
                            <Mail className="h-5 w-5 text-gray-400" />
                          </div>
                        </div>
                      </div>
                      <div>
                        <label htmlFor="booking-phone" className="block text-sm font-medium text-gray-700">
                          رقم الهاتف
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="tel"
                            id="booking-phone"
                            name="phone"
                            value={bookingData.phone}
                            onChange={handleBookingChange}
                            required
                            className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                          />
                          <div className="absolute inset-y-0 right-0 pl-3 flex items-center pointer-events-none">
                            <Phone className="h-5 w-5 text-gray-400" />
                          </div>
                        </div>
                      </div>
                      <div>
                        <label htmlFor="booking-notes" className="block text-sm font-medium text-gray-700">
                          ملاحظات إضافية (اختياري)
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <textarea
                            id="booking-notes"
                            name="notes"
                            rows="3"
                            placeholder="أذكر أي تفاصيل إضافية أو ملاحظات هامة"
                            value={bookingData.notes}
                            onChange={handleBookingChange}
                            className="block w-full pr-10 pl-4 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500 text-right"
                          ></textarea>
                          <div className="absolute top-3 right-0 pl-3 flex items-start pointer-events-none">
                            <MessageCircle className="h-5 w-5 text-gray-400" />
                          </div>
                        </div>
                      </div>
                      <div className="text-center mt-6">
                        <button
                          type="submit"
                          className="w-full bg-gradient-to-l from-blue-700 to-teal-600 text-white font-bold py-3 px-8 rounded-full hover:shadow-lg transition duration-300 shadow-md"
                        >
                          المتابعة للدفع
                        </button>
                      </div>
                    </form>
                  </>
                )}
                {formType === 'payment' && (
                  <>
                    <div className="text-center mb-6">
                      <h3 className="text-2xl font-bold text-blue-900">
                        إتمام عملية الدفع
                      </h3>
                      <p className="text-lg text-gray-600 mt-2">
                        إجمالي المبلغ: {selectedPackage.price}
                      </p>
                    </div>
                    {/* نموذج الدفع */}
                    <form onSubmit={handlePaymentSubmit} className="space-y-4">
                      <div>
                        <label htmlFor="cardNumber" className="block text-sm font-medium text-gray-700">
                          رقم البطاقة
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="text"
                            id="cardNumber"
                            name="cardNumber"
                            value={paymentData.cardNumber}
                            onChange={handlePaymentChange}
                            required
                            className="block w-full pr-10 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500"
                          />
                          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <CreditCard className="h-5 w-5 text-gray-400" />
                          </div>
                        </div>
                      </div>
                      <div className="flex gap-4">
                        <div className="w-1/2">
                          <label htmlFor="expiryDate" className="block text-sm font-medium text-gray-700">
                            تاريخ الانتهاء (MM/YY)
                          </label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <input
                              type="text"
                              id="expiryDate"
                              name="expiryDate"
                              value={paymentData.expiryDate}
                              onChange={handlePaymentChange}
                              required
                              placeholder="MM/YY"
                              className="block w-full pr-10 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500"
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <Calendar className="h-5 w-5 text-gray-400" />
                            </div>
                          </div>
                        </div>
                        <div className="w-1/2">
                          <label htmlFor="cvv" className="block text-sm font-medium text-gray-700">
                            رمز الأمان (CVV)
                          </label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <input
                              type="text"
                              id="cvv"
                              name="cvv"
                              value={paymentData.cvv}
                              onChange={handlePaymentChange}
                              required
                              className="block w-full pr-10 rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500"
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <Lock className="h-5 w-5 text-gray-400" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center mt-6">
                        <button
                          type="submit"
                          className="w-full bg-gradient-to-l from-blue-700 to-teal-600 text-white font-bold py-3 px-8 rounded-full hover:shadow-lg transition duration-300 shadow-md"
                        >
                          ادفع {selectedPackage.price}
                        </button>
                      </div>
                    </form>
                  </>
                )}
              </>
            ) : (
              <div className="text-center p-8">
                <CheckCircle className="w-16 h-16 mx-auto text-teal-500 mb-4" />
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  تمت عملية الدفع بنجاح!
                </h3>
                <p className="text-gray-600">
                  سنتواصل معك في أقرب وقت لتأكيد موعد التحليل.
                </p>
                <button
                  onClick={closeBookingModal}
                  className="mt-6 bg-gradient-to-l from-blue-700 to-teal-600 text-white font-bold py-2 px-6 rounded-full hover:shadow-lg transition duration-300"
                >
                  إغلاق
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Packages;
